<template>
  <div id="test">
    <textarea v-model="data" type="textarea" @keydown="keydown"></textarea>
  </div>
</template>
<script>
import Vue from "vue";
export default {
  name: "Test",
  data() {
    return {
      data: null
    };
  },
  methods: {
    keydown($event, $e) {
      if (
        ($event.target.value.match(/([\s])+/g) || []).length == 5 &&
        $event.code != "Backspace"
      ) {
        $event.preventDefault();
      }
      return $event;
    }

    /* keydown: function(e) {
      console.log(e);
    } */
  }
};
</script>




// WEBPACK FOOTER //
// src/components/Test.vue